export default {"src":"/_next/static/media/check.049baa3f.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};